import React from "react";

function Capricorn() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.158 496.158"
      enableBackground="new 0 0 496.158 496.158"
    >
      <path
        fill="#AF8D4A"
        d="M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
      />
      <g>
        <path
          fill="#DDD9BF"
          d="M163.342,114.72c-66.5-6.5-119.159,61.667-105.5,61.667c0,0,26.641-24.167,57.5-24.167
		c49.5,0,79.501,56.5,79.501,56.5s-2.053,14.255,16.666,6.667c0,0,25.767-17.686,27.284-33.874
		C238.793,181.512,215.814,119.849,163.342,114.72z"
        />
        <path
          fill="#DDD9BF"
          d="M333.79,114.72c-52.473,5.129-75.451,66.792-75.451,66.792
		c1.518,16.188,27.284,33.874,27.284,33.874c18.719,7.588,16.666-6.667,16.666-6.667s30.001-56.5,79.501-56.5
		c30.859,0,57.5,24.167,57.5,24.167C452.949,176.386,400.29,108.22,333.79,114.72z"
        />
      </g>
      <g>
        <path
          fill="#91552C"
          d="M376.448,168.048c-0.264-0.528-0.768-0.848-1.405-0.828c-38.123,1.622-63.338,41.401-65.413,44.786
		c-4.291,3.646,2.807,28.303,16.702,23.28c26.876-9.714,43.765-22.801,50.196-38.897
		C382.716,180.904,376.707,168.566,376.448,168.048z"
        />
        <path
          fill="#91552C"
          d="M187.069,212.006c-2.075-3.384-27.29-43.164-65.413-44.786c-0.638-0.02-1.142,0.299-1.405,0.828
		c-0.259,0.518-6.268,12.855-0.08,28.341c6.432,16.096,23.32,29.183,50.196,38.897C184.263,240.309,191.36,215.653,187.069,212.006z
		"
        />
      </g>
      <path
        fill="#9B6038"
        d="M322.771,247.38c0,0,9.485-19.35,3.794-28.457c0,0-6.83-5.312-17.074-6.83
	c0,0-26.488-14.923-46.881-30.733c-3.725-2.889-10.014-3.034-13.796-3.035h-0.03c-3.782,0.001-10.071,0.146-13.796,3.035
	c-20.393,15.81-46.881,30.733-46.881,30.733c-10.244,1.518-17.074,6.83-17.074,6.83c-5.691,9.106,3.795,28.457,3.795,28.457
	c1.896,7.588-1.896,23.524-1.896,23.524c-4.174,27.698,23.523,65.26,23.523,65.26c1.518,11.382,6.829,28.835,6.829,28.835
	c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833c0.164,0.044,8.4,2.182,15.162-6.833
	c0,0,27.318-27.318,30.354-32.63c0,0,5.313-17.453,6.83-28.835c0,0,27.697-37.563,23.523-65.26
	C324.668,270.904,320.874,254.968,322.771,247.38z"
      />
      <path
        fill="#AA693D"
        d="M248.814,178.326h-0.03c-3.782,0.001-10.071,0.146-13.796,3.035
	c-20.393,15.81-46.881,30.733-46.881,30.733c-10.244,1.518-17.074,6.83-17.074,6.83c-5.691,9.106,3.795,28.457,3.795,28.457
	c1.896,7.588-1.896,23.524-1.896,23.524c-4.174,27.698,23.523,65.26,23.523,65.26c1.518,11.382,6.829,28.835,6.829,28.835
	c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833C248.963,404.507,248.784,178.326,248.814,178.326z"
      />
      <path
        fill="#E0C199"
        d="M247.709,304.556c-48.1,0-51.254,31.608-51.254,31.608c1.518,11.382,6.829,28.835,6.829,28.835
	c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833c0.164,0.044,8.4,2.182,15.162-6.833
	c0,0,27.318-27.318,30.354-32.63c0,0,5.313-17.453,6.83-28.835C301.144,336.164,295.807,304.556,247.709,304.556z"
      />
      <path
        fill="#96592F"
        d="M248.784,387.421c-29.595,0-45.5-22.422-45.5-22.422c3.035,5.312,30.354,32.63,30.354,32.63
	c6.762,9.016,14.999,6.877,15.161,6.833c0.164,0.044,8.4,2.182,15.162-6.833c0,0,27.318-27.318,30.354-32.63
	C294.314,364.999,278.379,387.421,248.784,387.421z"
      />
      <g>
        <path
          fill="#494949"
          d="M191.648,228.409l-22.006-0.759c0,0-1.518,1.645-0.254,9.612c1.266,7.968,5.439,10.118,5.439,10.118
		l29.721,12.648l1.771-3.036L191.648,228.409z"
        />
        <path
          fill="#494949"
          d="M327.957,227.65l-22.007,0.759l-14.671,28.583l1.771,3.036l29.721-12.648
		c0,0,4.173-2.149,5.438-10.118C329.475,229.294,327.957,227.65,327.957,227.65z"
        />
        <path
          fill="#494949"
          d="M280.332,332.534c-14.991-7.623-30.615-9.561-31.272-9.639c-0.089-0.012-0.172,0.019-0.261,0.023
		c-0.088-0.004-0.171-0.035-0.26-0.023c-0.657,0.078-16.281,2.016-31.271,9.639c-0.493,0.251-0.811,0.75-0.83,1.302
		c-0.018,0.553,0.266,1.072,0.74,1.355l30.764,18.339c0.24,0.143,0.508,0.214,0.777,0.214c0.027,0,0.054-0.009,0.08-0.01
		c0.027,0.001,0.054,0.01,0.082,0.01c0.268,0,0.537-0.071,0.776-0.214l30.765-18.339c0.474-0.283,0.758-0.802,0.739-1.355
		C281.142,333.284,280.824,332.785,280.332,332.534z"
        />
        <path
          fill="#494949"
          d="M327.957,227.65l-0.043,0.002c0.408,1.254,0.675,2.605,0.797,4.014
		C328.695,228.462,327.957,227.65,327.957,227.65z"
        />
        <path
          fill="#494949"
          d="M281.348,364.701c-0.36-0.82-1.318-1.191-2.137-0.832c-10.592,4.661-18.443,5.263-23.34,1.787
		c-4.046-2.872-5.281-8.063-5.635-11.596c0.168-2.229,0.031-3.815,0.014-3.993c-0.079-0.831-0.774-1.449-1.587-1.46l-0.015-0.002
		c-0.891-0.081-1.674,0.592-1.746,1.485c-0.015,0.178-0.131,1.778,0.069,4.022c-0.304,3.5-1.461,8.609-5.427,11.489
		c-4.874,3.537-12.816,2.954-23.607-1.735c-0.821-0.359-1.776,0.019-2.132,0.841c-0.358,0.821,0.019,1.776,0.84,2.132
		c6.544,2.844,12.212,4.267,16.967,4.267c3.904,0,7.191-0.959,9.837-2.88c2.561-1.858,4.175-4.37,5.193-6.931
		c1.057,2.591,2.719,5.132,5.337,6.995c2.639,1.878,5.888,2.817,9.726,2.817c4.726,0,10.344-1.424,16.812-4.27
		C281.336,366.477,281.708,365.52,281.348,364.701z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Capricorn;
